// Single source of truth for how translation confidence is shown to users.
//
// We never display 100%: an absolute claim invites disputes and there's always
// residual risk in machine translation. Cap at 99% so the highest we ever show
// is "99%", not "certain". Thresholds match across every confidence surface
// (ring, inline %, per-segment badge).

export const CONFIDENCE_DISPLAY_MAX = 99;
export const HIGH_THRESHOLD = 85;
export const MEDIUM_THRESHOLD = 65;

// score: 0..1 -> integer percent, capped at 99.
export function confidencePercent(score) {
  return Math.min(CONFIDENCE_DISPLAY_MAX, Math.round((score || 0) * 100));
}

// percent: 0..100 -> 'high' | 'medium' | 'low'.
export function confidenceLevel(percent) {
  if (percent >= HIGH_THRESHOLD) return 'high';
  if (percent >= MEDIUM_THRESHOLD) return 'medium';
  return 'low';
}
